import { DepartmentProperties } from '@/infrastructure/network/Monitaro/schema/models'

export interface IDepartmentProps {
  id?: string
  name: string | null
  order: number | null
  createdAt: string | null
  updatedAt: string | null
  properties: DepartmentProperties | null
}

export default class DepartmentEntity {
  private _props: IDepartmentProps

  constructor(props?: IDepartmentProps | null) {
    this._props = EmptyDepartmentPropsFactory(props)
  }

  get props(): IDepartmentProps {
    return this._props
  }

  get clone(): IDepartmentProps {
    return structuredClone(this._props)
  }

  get id(): string | undefined {
    return this._props.id
  }

  get name(): string | null {
    return this._props.name
  }

  get order(): number | null {
    return this._props.order
  }

  get createdAt(): string | null {
    return this._props.createdAt
  }

  get updatedAt(): string | null {
    return this._props.updatedAt
  }

  get properties(): DepartmentProperties | null | undefined {
    return this._props.properties
  }
}

export const headers = [{ text: 'ID', value: 'id' }]

export const EmptyDepartmentPropsFactory = (props?: Partial<IDepartmentProps> | null): IDepartmentProps => ({
  name: null,
  order: null,
  createdAt: null,
  updatedAt: null,
  properties: null,
  ...props
})
